/* VÆLD — global focus trap.
   Keeps Tab focus inside whichever modal layer is open (cart drawer,
   facets, size guide, search, mobile menu, lightbox). Works off the
   shared convention: an open layer has [aria-modal="true"] and either
   aria-hidden="false" or .is-open. No per-component wiring needed. */

(function () {
  'use strict';

  var SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function openLayer() {
    var layers = document.querySelectorAll('[aria-modal="true"], [data-mobile-menu]');
    var found = null;
    layers.forEach(function (l) {
      if (l.classList.contains('is-open') || l.getAttribute('aria-hidden') === 'false') found = l;
    });
    return found;
  }

  function visibleFocusables(container) {
    return Array.prototype.filter.call(container.querySelectorAll(SELECTOR), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var layer = openLayer();
    if (!layer) return;

    var f = visibleFocusables(layer);
    if (!f.length) return;

    var first = f[0];
    var last = f[f.length - 1];

    if (!layer.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
      return;
    }
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
